import { STATE_KEY } from '../constants';

export const getState = (state) => state[STATE_KEY];
